import { Center, Text, Icon, VStack, HStack, Link, Wrap, WrapItem } from '@chakra-ui/react';
import ContentContainer from '~/containers/Content';

import platformAtom from '~/recoil/atom/platform';
import { useRecoilValue } from 'recoil';

import { AiFillPhone, AiFillEnvironment } from 'react-icons/ai';
import { FaLine } from 'react-icons/fa';
import { IoHome } from 'react-icons/io5';

import versionInfo from '~/versionInfo';

export default function Footer() {
  const platform = useRecoilValue(platformAtom);

  const { name, phoneNumber, location, socialLink } = platform;

  return (
    <Center bg="gray.100" py={3}>
      <ContentContainer bg="gray.100">
        <VStack align="stretch">
          <Text fontSize="sm" fontWeight="bold" color="secondary">
            {name}
          </Text>

          <HStack>
            <Icon as={AiFillPhone} color="secondary" boxSize="1rem" />
            <Text fontSize="sm" color="secondary">
              {phoneNumber + ' 週一~週五:09:00-18:00'}
            </Text>
          </HStack>

          <HStack>
            <Icon as={AiFillEnvironment} color="secondary" boxSize="1rem" />
            <Text fontSize="sm" color="secondary">
              {location.address}
            </Text>
          </HStack>

          <HStack>
            <Icon as={IoHome} color="secondary" boxSize="1rem" />
            <Text fontSize="sm" color="secondary">
              糧澄即食有限公司/90411623
            </Text>
          </HStack>

          {socialLink.LINE && (
            <HStack>
              <Icon as={FaLine} color="secondary" boxSize="1rem" />
              <Link href={socialLink.LINE || ''} target="_blank">
                <Text fontSize="sm" color="secondary">
                  LINE
                </Text>
              </Link>
            </HStack>
          )}

          <HStack spacing={0.5}>
            <Wrap spacing={1}>
              <WrapItem>
                <Text fontSize="xs" color="secondary">
                  © 2021 {name} CO., LTD. All Rights Reserved.
                </Text>
              </WrapItem>
              <WrapItem>
                <Link fontSize="xs" color="primary" href="https://www.weserve.tw/" isExternal>
                  weserve .
                </Link>
              </WrapItem>
              <WrapItem>
                <Text fontSize="xs" color="secondary">
                  version {versionInfo.version}
                </Text>
              </WrapItem>
            </Wrap>
          </HStack>
        </VStack>
      </ContentContainer>
    </Center>
  );
}
